import React from 'react';
import MyAddressesStore from './MyAddressesStore';
import MyAddressesActions from './MyAddressesActions';
import AddressUS from 'ViewModels/Components/Addresses/Templates/Display_US';
import AddressMX from 'ViewModels/Components/Addresses/Templates/Display_MX';
import AddressGB from 'ViewModels/Components/Addresses/Templates/Display_GB';
import AddressSG from 'ViewModels/Components/Addresses/Templates/Display_SG';
import AddressLoader from '../../Addresses/AddressLoader';
import { getUrlParameter, buildQueryString } from '../../../../Scripts/tools';

export default class MyAddressesContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = MyAddressesStore.getState();
		this.onChange = this.onChange.bind(this);
		this.displayAddress = this.displayAddress.bind(this);
		this.button = this.button.bind(this);
	}

	componentDidMount() {
		MyAddressesStore.listen(this.onChange);
		MyAddressesActions.getAddresses();
	}

	componentWillUnmount() {
		MyAddressesStore.unlisten(this.onChange);
	}

	onChange(state) {
		this.setState(state);
	}

	displayAddress(address) {
		if (!address) { return null; }

        let displayTemplate = '';
        switch (address.country.toLowerCase()) {
                case 'us':
                    displayTemplate = <AddressUS line1={address.line1} line2={address.line2} city={address.city} stateProvince={address.stateProvince} postalCode={address.postalCode} country={address.country} />;
                    break;
                case 'mx':
                    displayTemplate = <AddressMX line1={address.line1} line2={address.line2} city={address.city} postalCode={address.postalCode} stateProvince={address.stateProvince} country={address.country} />;
                    break;
        		case 'gb':
        			displayTemplate = <AddressGB line1={address.line1} line2={address.line2} city={address.city} postalCode={address.postalCode} stateProvince={address.stateProvince} country={address.country} />;
        			break;
                case 'sg':
                    displayTemplate = <AddressSG line1={address.line1} line2={address.line2} city={address.city} postalCode={address.postalCode} stateProvince={address.stateProvince} country={address.country} />;
                break;
            default:
                displayTemplate = <AddressUS line1={address.line1} line2={address.line2} city={address.city} stateProvince={address.stateProvince} postalCode={address.postalCode} country={address.country} />;
                break;
        }

		let warning = address.isValid || (
			<div>
				<span className="text-danger">{this.props.resources["GLOBAL.InvalidAddress.Text"]}</span>
			</div>
		)

        return (<div>
            {displayTemplate}
            {warning}
        </div>);

	}

	displayAdditionalAddress(address, key) {
        if (!address) { return null; }
		var editMode = this.state.showEditAdditionalAddress[key];
		return (
			<div key={key} className="my-addresses-address my-addresses-additional">
				{ editMode ? null : this.displayAddress(address) }
				{ editMode ? this.additionalAddressEditor(key, address) : null }
				{ editMode ? null : this.button(this.props.resources["PWS.Globals.EditButton"], MyAddressesActions.toggleEditAdditionalAddress.bind(this, key, true)) }
				{ editMode ? null : this.button(this.props.resources["PWS.Globals.DeleteButton"], MyAddressesActions.deleteAdditionalAddress.bind(this, address.code, "Do you really want to delete this address?")) }
			</div>
		);
	}

	additionalAddressEditor(key, address) {
		var refName = "myAdditionalAddress_" + key;
		return (
			<div className="my-addresses-additional-editor">
				<AddressLoader ref={refName} autoCompleteGroup={refName} initialValues={address} selectedCountry={address.country} allowedCountries={window.jenkon.country} schema="Default" validationResources={this.props.resources}/>
				{ this.saveOrCancel(this.props.resources["PWS.Globals.CancelButton"], MyAddressesActions.toggleEditAdditionalAddress.bind(this, key, false), this.props.resources["PWS.Globals.SaveButton"], this.updateAdditionalAddress.bind(this, refName, key)) }
			</div>
		);
	}

	createAdditionalAddressEditor() {
		return (
			<div className="my-addresses-additional-editor">
				<AddressLoader ref="newAdditionalAddress" autoCompleteGroup="additional" initialValues={''} allowedCountries={window.jenkon.country} selectedCountry={this.props.countryCode || window.jenkon.country} schema="Default" validationResources={this.props.resources}/>
				{ this.saveOrCancel(this.props.resources["PWS.Globals.CancelButton"], MyAddressesActions.toggleCreateAdditionalAddress.bind(this, false), this.props.resources["PWS.Globals.SaveButton"], this.createAdditionalAddress.bind(this)) }
			</div>
		);
	}

	button(buttonText, handleClick) {
		return (
			<button onClick={handleClick} className="button my-addresses-button">{buttonText}</button>
		);
	}

	saveOrCancel(cancelText, handleCancel, saveText, handleSave)  {
		return (
			<div>
				{ this.button(cancelText, handleCancel) }
				{ this.button(saveText, handleSave) }
			</div>
		);
	}

	saveHomeAddress() {
		if (this.refs.homeAddress.isValidAddress()) {
			this.refs.homeAddress.validateAddress(true, null).then(result => {
				if (result) {
					MyAddressesActions.saveHomeAddress(this.refs.homeAddress.getAddressValues());
                }
			});
        }
	}

	saveShippingAddress() {
        if (this.refs.shippingAddress.isValidAddress()) {
			this.refs.shippingAddress.validateAddress(true, null).then(result => {
				if (result) {
					MyAddressesActions.saveShippingAddress(this.refs.shippingAddress.getAddressValues());
				}
			});
        }
	}

	createAdditionalAddress() {
        if (this.refs.newAdditionalAddress.isValidAddress()) {
			this.refs.newAdditionalAddress.validateAddress(true, null).then(result => {
				if (result) {
					MyAddressesActions.createAdditionalAddress(this.refs.newAdditionalAddress.getAddressValues());
					MyAddressesActions.toggleCreateAdditionalAddress(false);
				}
			});
        }
	}

	updateAdditionalAddress(refName, key) {
		this.refs[refName].validateAddress(true, null).then(result => {
			if (result) {
				MyAddressesActions.updateAdditionalAddress(this.refs[refName].getAddressValues(), key);
				MyAddressesActions.toggleEditAdditionalAddress(key, false);
			}
		});
	}

	checkShippingSameAsHome() {
		return !(this.state.showEditShippingAddress || (this.state.shippingAddress && this.state.shippingAddress.code));
	}

	render() {
		var returnUrl = getUrlParameter('redirectUrl');// + buildQueryString({
			//shipToName: getUrlParameter('shipToName'),
			//shipToPhone: getUrlParameter('shipToPhone')
		//});
    return (
      <div id="my-addresses-section" className="site-container icon_button_content animate-in" aria-live="assertive">
				<div className="blurb text-center">
					<div className="title">{this.props.resources["PWS.MyAccount.MyAddresses"]}</div>
				</div>
				<div className="section-wrapper clearfix">
					{returnUrl? <a className="section-back-link" href={returnUrl}>&laquo; &nbsp;{this.props.resources["PWS.MyAccount.ReturnToCheckout"]}</a> : <a href="javascript:void(0);" className="section-back-link" onClick={this.props.setView.bind(this)}>&laquo; &nbsp;{this.props.resources["PWS.MyAccount.BackToAccountButton"]}</a> }
					<div className="dotted-HR"></div>
					<div>
						<div className="my-addresses-address">
							<h3>{this.props.resources["PWS.MyAccount.HomeAddress"]}</h3>
						{this.state.showEditHomeAddress ? <AddressLoader ref="homeAddress" initialValues={this.state.homeAddress} allowedCountries={window.jenkon.country} selectedCountry={this.state.homeAddress != null ? this.state.homeAddress.country : window.jenkon.country} schema="Default" validationResources={this.props.resources}/> : this.displayAddress(this.state.homeAddress) }
							{ this.state.showEditHomeAddress? this.saveOrCancel(this.props.resources["PWS.Globals.CancelButton"], MyAddressesActions.toggleEditHomeAddress.bind(this, false), this.props.resources["PWS.Globals.SaveButton"], this.saveHomeAddress.bind(this)) : this.button(this.props.resources["PWS.Globals.EditButton"], MyAddressesActions.editHomeAddress) }
						</div>
						{this.state.showShippingAddress?
						<div className="my-addresses-address">
							<h3>{this.props.resources["PWS.MyAccount.ShippingAddress"]}</h3>
							<div className="my-addresses-ship_to_home">
								<input type="checkbox" checked={this.checkShippingSameAsHome.apply(this)} disabled={!this.state.showEditShippingAddress} onChange={() => MyAddressesActions.toggleShippingSameAsHome(!this.state.shippingSameAsHome)} /> Same As Home Address
							</div>
							{this.state.showEditShippingAddress ? <AddressLoader autoCompleteGroup="shipping" ref="shippingAddress" allowedCountries={window.jenkon.country} initialValues={this.state.shippingAddress} selectedCountry={this.state.shippingAddress != null ? this.state.shippingAddress.country : window.jenkon.country} schema="Default" validationResources={this.props.resources} /> : this.displayAddress(this.state.shippingAddress) }
							{ this.state.showEditShippingAddress? this.saveOrCancel(this.props.resources["PWS.Globals.CancelButton"], MyAddressesActions.toggleEditShippingAddress.bind(this, false), this.props.resources["PWS.Globals.SaveButton"], this.saveShippingAddress.bind(this)) : this.button(this.props.resources["PWS.Globals.EditButton"], MyAddressesActions.editShippingAddress) }
						</div> : null
						}
						{this.state.showAdditionalAddresses?
						<div className="my-addresses-address">
							<h3>{this.props.resources["PWS.MyAccount.AdditionalAddresses"]}</h3>
							{ this.state.showCreateAdditionalAddress? this.createAdditionalAddressEditor.apply(this) : this.button(this.props.resources["PWS.MyAccount.AddNewAddress"], MyAddressesActions.addAdditionalAddress) }
							{ this.state.additionalAddresses.map(this.displayAdditionalAddress.bind(this)) }
						</div> : null
						}
					</div>
				</div>
			</div>
    );
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/MyAddresses/MyAddressesContainer.js